/**
 * クラス
 *
 */

/** 表示区分
 * @param NONE 非表示
 * @param ALWAYS 出発地＆目的地
 * @param DISPLAY_ONLY_ARRIVAL_LOCATION 目的地
 * */
export type RegionDisplayType = (typeof RegionDisplayType)[keyof typeof RegionDisplayType];
export const RegionDisplayType = { NONE: '0', ALWAYS: '1', DISPLAY_ONLY_ARRIVAL_LOCATION: '2' } as const;

/** IATAエリア
 * @param TC1 IATAエリア1
 * @param TC2 IATAエリア2
 * @param TC3 IATAエリア3
 * @param TC4 IATAエリア4
 * */
export type IataType = (typeof IataType)[keyof typeof IataType];
export const IataType = { TC1: '1', TC2: '2', TC3: '3', JP: '4' } as const;

/**
 * 地域情報 AKAMAIデータのためスネーク型
 * @param name 地域名
 * @param english_name 地域名(英語用)
 * @param code 地域コード
 * @param display_type 表示区分 @see RegionDisplayType
 * @param area IATAエリア @see IataType
 * @param order 表示順
 * @param index_list インデックス配列
 * @param index_list_type 空港名インデックスタイプ (0:日本語,1:英語,2:国）
 */
export interface Region {
  name: string;
  english_name: string;
  code: string;
  display_type: RegionDisplayType;
  area: IataType;
  order: number;
  index_list: string;
  index_list_type: number | null;
}
